import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getGroSettings, updateGroSettings } from "@/services/groSettings";
import type { GroSettingsUpdateIn } from "@/types/gro";

export function useGroSettings(enabled = true) {
  return useQuery({
    queryKey: ["gro_settings"],
    queryFn: () => getGroSettings(),
    enabled,
    staleTime: 20_000,
  });
}

export function useUpdateGroSettings() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (body: GroSettingsUpdateIn) => updateGroSettings(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["gro_settings"] });
    },
  });
}
